import moment from 'moment';
import queryString from 'qs';

const getOperatorBreaksRequest = (filter) =>
  queryString.stringify({
    ...((filter?.date || filter?.paramsDate) && {
      date: moment(filter.date || filter.paramsDate).format('DD-MM-YYYY'),
    }),
    ...(filter?.operatorId && { operatorId: filter.operatorId }),
    sort: 'startedAt.asc',
  });

export default getOperatorBreaksRequest;
